import { useSearchPageData } from '@/app/components/search/searchPageDataProvider.tsx';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import { APIStatusEnum } from '@/app/components/search/common/reloadData/APIStatusEnum.ts';
import { dynamicFiltersSearchKey } from '@/app/common/filters/core/dynamicFiltersSearchKey.ts';

type FilterBarLoading = { isLoading: boolean };

export const useFilterBarLoading = (waitForDynamicFilters = false): FilterBarLoading => {
  const { productsData, isLoading, dynamicFilters } = useSearchPageData();
  const { searchParams } = usePageWrapperData();

  // Bars built from the dynamic filters wait for the response that describes the search on screen:
  // without it every option reads as available, so they would show chips it then withdraws.
  if (waitForDynamicFilters) return { isLoading: dynamicFilters?.searchKey !== dynamicFiltersSearchKey(searchParams) };

  const hasNoResultsYet = (productsData?.apiStatus || APIStatusEnum.NORESULTS) === APIStatusEnum.WAIT;

  return { isLoading: isLoading || hasNoResultsYet };
};
